// extracted by mini-css-extract-plugin
export default {"noneToDelete":"noneToDelete---jPZv2"};